import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthenticationService } from '../services';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
loginForm: FormGroup;
registerForm: FormGroup;
recoverForm: FormGroup;
showLoginForm = true;
showSignupForm = false;
showRecoverForm = false;
recoverNoti = true;
submitted = false;
loading = false;
success = true;
returnUrl: string;
error = false;
recoverBtn = true;
getFullYear: number = new Date().getFullYear();
invalidEmail = false;
checked = true;
  constructor(
    private readonly formBuilder: FormBuilder,
    public router:Router,
    private route: ActivatedRoute,
    private notification: NzNotificationService,
    private authenticationService: AuthenticationService
    ) {
        if (this.authenticationService.currentUserValue) { 
          this.onLoginSuccess()
      }
    }

    updateConfirmValidator(): void {
      /** wait for refresh value */
      Promise.resolve().then(() => this.registerForm.controls.confirmPassword.updateValueAndValidity());
    }

    confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
      if (!control.value) {
        return { required: true };
      } else if (control.value !== this.registerForm.controls.password.value) {
        return { confirm: true, error: true };
      }
      return {};
    };

    onLoginSuccess(): void {
      this.route.queryParams.subscribe(params => {
        const returnUrl = params['returnUrl'];        
        if(returnUrl){
          this.router.navigateByUrl(returnUrl);
        }else{
          this.router.navigate(['/home']);
        }        
      });      
    }

    ngOnInit(): void {      
      this.loginForm = this.formBuilder.group({
        email: ['', Validators.required],
        password: ['', Validators.required],
        remember: [true]
      });
      this.registerForm = this.formBuilder.group({
        email: ['', Validators.required],
        password: ['', Validators.required],
        confirmPassword : [null, [Validators.required, this.confirmationValidator]],
      });
      this.recoverForm = this.formBuilder.group({
        email: ['', Validators.required]
      });
    }

    get f() { return this.loginForm.controls; }
    get r() { return this.registerForm.controls; }
    get recover() { return this.recoverForm.controls; }

  
  loginSubmit(): void {
    this.submitted = true;
    this.success = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
        return;
    }

    this.loading = true;

    for (const i in this.loginForm.controls) {
      this.loginForm.controls[i].markAsDirty();
      this.loginForm.controls[i].updateValueAndValidity();      
    }
    if(this.loginForm.status == "VALID"){
      this.authenticationService.login(this.f.email.value, this.f.password.value)
      .pipe(first())
      .subscribe(
          data => {
              // this.router.navigate([this.returnUrl]);
              // this.router.navigate(['/home']);
              this.onLoginSuccess();
              this.loginSuccessNoti('success');
          },
          error => {
            this.success = false;
            console.log('error', error);
            
            this.loading = false;
          });
    }
    
  } 

  loginSuccessNoti(type: string): void {
    // this.notification.create(
    //   type,
    //   'Đăng nhập thành công',
    //     'Chào mừng bạn quay trở lại với DanceSport!'
    // );
  }

  registerSubmit(): void {
    
    this.submitted = true;
    this.success = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }

    this.loading = true;
    
    for (const i in this.registerForm.controls) {
      this.registerForm.controls[i].markAsDirty();
      this.registerForm.controls[i].updateValueAndValidity(); 
    }
    
    
    if(this.registerForm.status == "VALID"){
      const value = {
        "email": this.r.email.value,
        "name": this.r.email.value,
        "role": "user",
        "password": this.r.password.value
      }      
      this.authenticationService.register(value)
      .pipe(first())
      .subscribe(
          data => {
              // this.router.navigate([this.returnUrl]);
              this.router.navigate(['/home']);
              this.loginSuccessNoti('success');
          },
          error => {
            this.success = false;
            this.error = true;
            this.loading = false;
          });
    }   
    
  }

  recoverSubmit(): void {
    this.recoverBtn = false;
    this.invalidEmail = false;
    for (const i in this.recoverForm.controls) {
      this.recoverForm.controls[i].markAsDirty();
      this.recoverForm.controls[i].updateValueAndValidity(); 
    }
    if(this.recoverForm.status == "VALID"){
      const value = {
        "email": this.recover.email.value
      }   
      this.authenticationService.recover(value)
      .pipe(first())
      .subscribe(
          data => {
            this.recoverNoti = false;
            this.recoverBtn = true;
            this.invalidEmail = false;
          },
          error => {
            this.success = false;
            this.error = true;
            this.loading = false;
            this.recoverBtn = true;
            this.invalidEmail = true;
          });     
      
    }
    
  }
  

  showSignup(){
    this.showSignupForm = true;
  }
  showLogin(){
    this.showLoginForm = true;
  }
  showRecover(){
    this.showRecoverForm = true;
  }
}
